export default __webpack_public_path__ + "static/media/DSC_0549.fa17f73c.webp";